<script>
import { HorizontalBar } from 'vue-chartjs';
import _ from 'lodash';

const MIN_FALTAS_EVASAO = 50;
const MIN_FALTAS_PROX_EVASAO = 40;

export default {
  extends: HorizontalBar ,
  props: {
    alunos: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    alunos(){
      let labels = [],
          faltas = [],
          faltas_consecutivas = [],
          colors= [];

      for(let aluno of this.alunos){
        labels.push(aluno.nome);
        faltas.push(aluno.faltas);
        faltas_consecutivas.push(aluno.faltas_consecutivas);
        if (aluno.faltas_consecutivas >= MIN_FALTAS_EVASAO){
          colors.push('darkred');
        }
        else if (aluno.faltas_consecutivas >= MIN_FALTAS_PROX_EVASAO){
          colors.push('#ff3b00');
        }
        else 
          colors.push('#ff9900');
      }
      this.renderChart({
        labels,
        datasets: [
          {
            label: 'Faltas totais',
            backgroundColor: '#DCE775',
            data: faltas
          },
          {
            label: 'Faltas consecutivas',
            backgroundColor: colors,
            data: faltas_consecutivas
          },
        ]
      }, {
        maintainAspectRatio: false,
        spanGaps: false,
        responsive: true,
        scales: {
          xAxes: [{
            ticks: {
              reverse: false,
              stepSize: 5,
              beginAtZero: true,
            }
          }],
        },
        legend: {
           display: false
        },
      });
    }
  },
}
</script>

<style>

</style>
